import { FormationDetailProps } from "@/types/formation";

export const ariFormation: FormationDetailProps = {
  id: "10",
  title: "Formation ARI (Appareil Respiratoire Isolant)",
  description: "Cette formation ARI répond à l'obligation du code du travail (article R.4323-106 et du document unique) sur une formation à cette équipement de protection individuel.",
  duration: "7 heures (1 jour)",
  category: "Sécurité",
  imageSrc: "/images/formations/Ari.webp",
  slug: "appareil-respiratoire-isolant",
  reference: "F-ARI",
  price: "Sur devis – nous contacter",
  targetAudience: "Toute personne devant porter un appareil respiratoire isolant dans le cadre de son activité dans son entreprise",
  prerequisites: "Être âgé de 18 ans\nÊtre apte médical pour le port d'un ARI",
  objectives: [
    "Savoir utiliser un appareil respiratoire isolant dans une atmosphère confinée en évoluant en toute sécurité",
    "Être capable de connaître et utiliser l'ARI",
    "Sensibiliser les personnes aux risques d'hypoxiques, gaz (H2S, etc)",
    "Être capable de connaître à respecter avant, pendant et après une intervention avec un ARI",
    "Savoir dégager une personne inanimée avec l'ARI, effectuer un dégagement d'urgence"
  ],
  program: [
    {
      title: "Partie théorique 40%",
      items: [
        "Introduction",
        "Présentation de la formation",
        "Le risque",
        "Objectifs de la formation",
        "Les consignes",
        "La réglementation",
        "Les contraintes physiologiques",
        "Les fonctionnements respiratoires",
        "Le système respiratoire",
        "Les facteurs aggravants",
        "Les dangers des fumées",
        "L'air respirable ou non respirable",
        "La classification des différents appareils respiratoires",
        "Les appareils filtrants",
        "Les appareils isolants",
        "Le piège mortel",
        "Le manque",
        "Les différents types de masques"
      ]
    },
    {
      title: "Partie pratique 60%",
      items: [
        "Description et principe du fonctionnement de l'ARI",
        "Le contrôle",
        "Le suivi",
        "La ligne de vie (ligne guide)",
        "Les exemples",
        "La procédure",
        "L'utilisation et les règles de conduites",
        "Exercice avec utilisation de l'ARI",
        "Procédures",
        "Évolutions avec l'appareil respiratoire isolé",
        "Le stockage et l'entretien",
        "Le nettoyage et la désinfection",
        "L'utilisation et la maintenance",
        "Le stockage",
        "Exercice d'évacuation",
        "Exercices pratiques en situation des risques et déplacement du personnel avec respect des consignes de sécurité",
        "Procédure d'appeler aux secours pour victime par chaleur, une pièce, une technologie, une personne inconsciente"
      ]
    }
  ],
  pedagogicalMethods: [
    "Exposés interactifs, démonstrations par le formateur, exercice pratique réels avec port de l'ARI"
  ],
  evaluationMethods: [
    "En 1er jour de la formation : Questionnaire des besoins et positionnement de l'apprenant",
    "Pendant la formation : Atelier pratique en situation réelle + exercices applicatifs",
    "Fin de formation : QCM pour évaluation des acquis + évaluation de satisfaction à chaud",
    "Après la formation : Évaluation à froid pour vérifier les compétences de l'apprenant"
  ],
  certification: "Cette action de formation sera validée par une attestation de compétence nominative, après la réalisation du QCM final par l'évaluation des acquis.",
  registrationProcess: [
    "Inscription par téléphone, par mail ou par le site internet",
    "Délai d'accès selon un agenda interne de session de l'entreprise",
    "Inscription 15 jours avant le début de la formation"
  ],
  accessibilityCriteria: "Pour toute personne en situation d'handicap, Nous sommes susceptibles d'accueillir les personnes moins de nous contacter au préalable pour étudier toute situation.",
  formatterInfo: {
    name: "Sebastien Davrainville - SDPSI Formation",
    phone: "06.22.61.04.09",
    email: "sdpsiformation@orange.fr",
    website: "www.sdpsi-formations.fr"
  }
};
